<div class="expectations-container">
  @for (form of expectationForms; track form) {
    <div class="expectation-row">
      <app-expectation-item
        (remove)="removeExpectation($index)"
        [expectationForm]="form"
        [index]="$index + 1"
        [isReadOnly]="isReadOnly()"
        [valueOptions]="valueOptions()"
        [shouldDisplayDeleteButton]="!isReadOnly() && expectationForms.length > 1"
      ></app-expectation-item>
    </div>
  }

  @if (!isReadOnly()) {
    <app-button type="ghost" (pressed)="addExpectation()">
      <mat-icon>add</mat-icon>
      <ng-container i18n="@@ruleset.addexpectation">Add expectation</ng-container>
    </app-button>
  }
</div>
